// @import
import { ensureProps } from "@src/js/lib/ensure";
import { viewport } from "@src/js/lib/viewport";
import Alpine from "alpinejs";
import { isYouTubeProvider } from "vidstack";

Alpine.directive("hero-films-single", async (element, {}, { cleanup, effect }) => {
  const dom = {
    player: element.querySelector("media-player"),
  };

  const hasPlayer = ensureProps(dom, "player");
  let isAutoplayMode = true;
  let provider;
  let isYoutube = false;

  dom.player?.addEventListener("provider-change", (event) => {
    provider = event.detail;
    if (isYouTubeProvider(provider)) {
      provider.cookies = true;
      isYoutube = true;
    }
  });

  if (!hasPlayer) {
    console.warn("No media player found in hero films single component");
    return;
  }

  dom.player.subscribe(({ canPlay }) => {
    if (canPlay) {
      dom.player.play();
      const poster = dom.player.querySelector("media-poster");
      poster?.removeAttribute("data-visible");
    }
  });

  effect(() => {
    if (viewport.width && viewport.height) {
      const ratio = Math.max(viewport.width / viewport.height, 1.77778);
      element.style.setProperty("--screen-ratio", ratio.toString());
    }
  });

  function handleClick(e: MouseEvent) {
    if (!e.target || !(e.target instanceof HTMLElement)) {
      return;
    }
    // Avoid toggling play on social icons interaction
    if (e.target.closest(".c-hero-films-single__social-icons")) {
      return;
    }
    togglePlay();
  }

  const togglePlay = () => {
    element.removeEventListener("click", handleClick);
    const isPlaying = dom.player?.state.playing;
    // Autoplay mode :
    // - unmute
    // - seek to 0
    // - revert to default behaviour
    if (isAutoplayMode) {
      dom.player.muted = false;
      if (isPlaying) {
        if (isYoutube) {
          // See https://github.com/vidstack/player/pull/1722
          provider.postMessage({
            event: "command",
            func: "seekTo",
            args: [0, true],
          });
        } else {
          dom.player.currentTime = 0;
        }
      } else {
        // Force unmuted before start
        dom.player.removeAttribute("data-muted");
      }
      element.classList.add("c-hero-films-single--playing");
      isAutoplayMode = false;
    } else {
      // Handle play/pause
      if (isPlaying) {
        dom.player.pause();
        element.classList.remove("c-hero-films-single--playing");
      } else {
        dom.player.subscribe(({ canPlay }) => {
          canPlay && dom.player.play();
          element.classList.add("c-hero-films-single--playing");
        });
      }
    }
  };

  element.addEventListener("click", handleClick);

  cleanup(() => {
    element.removeEventListener("click", handleClick);
  });
});
